var map = {
	"./cnn-money-x2.png": 2032,
	"./cnn-money.png": 2241,
	"./economist-x2.png": 2033,
	"./economist.png": 2242,
	"./mashable-x2.png": 2034,
	"./mashable.png": 2243,
	"./tech-crunch-x2.png": 2035,
	"./tech-crunch.png": 2244,
	"./thenewyorker-x2.png": 2036,
	"./thenewyorker.png": 2245,
	"./thrillist-x2.png": 2037,
	"./thrillist.png": 2246,
	"./time-x2.png": 2038,
	"./time.png": 2247,
	"./usa-today-x2.png": 2039,
	"./usa-today.png": 2248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2240;